<a [href]="fileUrl()" target="_blank" rel="noopener noreferrer" class="hidden" #fileLink>Open File</a>
